import React from 'react';
import PropTypes from 'prop-types';
import Masthead from '../Masthead/Masthead.js';
import Footer from '../Footer/Footer.js';
import detectBrowser from '../../utils/detectBrowser.js';
import pageStyles from './page.css.js';
/* eslint-env browser */

var componentDefault = detectBrowser.ie11 ? 'div' : 'main';

var Page = function Page(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? componentDefault : _ref$component,
      children = _ref.children,
      headerSlot = _ref.headerSlot,
      footerSlot = _ref.footerSlot;
  return React.createElement("div", {
    className: pageStyles.Page
  }, React.createElement("div", {
    className: pageStyles.wrapper
  }, headerSlot || React.createElement(Masthead, null), React.createElement(Component, {
    className: pageStyles.main,
    role: "main"
  }, children), footerSlot || React.createElement(Footer, null)));
};

Page.displayName = 'Page';
Page.propTypes = process.env.NODE_ENV !== "production" ? {
  headerSlot: PropTypes.node,
  footerSlot: PropTypes.node,
  children: PropTypes.node,
  component: PropTypes.string
} : {};
export default Page;
export { Page };